import { render, staticRenderFns } from "./club-pricing-matrix-item.vue?vue&type=template&id=b31d28de"
import script from "./club-pricing-matrix-item.vue?vue&type=script&lang=ts"
export * from "./club-pricing-matrix-item.vue?vue&type=script&lang=ts"
import style0 from "./club-pricing-matrix-item.vue?vue&type=style&index=0&id=b31d28de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports